import React, { Component } from 'react'
import { Router } from 'react-router-dom'
import { Provider } from 'react-redux'
import ReactGA from 'react-ga'

import './App.css'
import './styles/main.css'
import './styles/shared.css'
import './styles/animation.css'
import './styles/print.css'

import Routes from './Routes'
import { store } from './store'
import history from './history'

class App extends Component {

  componentDidMount() {
    ReactGA.initialize('UA-34546201-12')
    history.listen(location => ReactGA.pageview(location.pathname))
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <Routes />
        </Router>
      </Provider>
    )
  }
}

export default App


// WEBPACK FOOTER //
// ./src/App.js